import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const BASE_URL = `${QUALITY_SERVICE_API_URL}/hub/demo-env-mgmt`;

// Whether the current user is on the Demo Env Mgmt allowlist — drives both the left-nav item's
// visibility and the /demo-env-mgmt route gate. Safe to call for any authenticated Hub user.
export async function getDemoEnvMgmtAccess() {
  const res = await api.get(`${BASE_URL}/access`);
  return res.data.authorized;
}

// Predefined options for the Scope tab (accounts/projects/datasources/users) plus the current
// authorized-users list, for the Manage options tab. Only callable by authorized users — the
// backend returns 403 otherwise.
export async function getDemoEnvMgmtOptions() {
  const res = await api.get(`${BASE_URL}/options`);
  return res.data;
}

export async function addAuthorizedUser(email, isAdmin = false) {
  const res = await api.post(`${BASE_URL}/authorized-users`, { email, isAdmin });
  return res.data;
}

export async function removeAuthorizedUser(id) {
  await api.delete(`${BASE_URL}/authorized-users/${id}`);
}

export async function addProject({ projectId, label, demoEnvAccountId }) {
  const res = await api.post(`${BASE_URL}/projects`, { projectId, label, demoEnvAccountId });
  return res.data;
}

export async function removeProject(id) {
  await api.delete(`${BASE_URL}/projects/${id}`);
}

export async function addDatasource({ datasourceId, label, kind, demoEnvProjectId, sourceDatasourceId }) {
  const res = await api.post(`${BASE_URL}/datasources`, { datasourceId, label, kind, demoEnvProjectId, sourceDatasourceId });
  return res.data;
}

export async function removeDatasource(id) {
  await api.delete(`${BASE_URL}/datasources/${id}`);
}

export async function addUser({ email, demoEnvAccountId }) {
  const res = await api.post(`${BASE_URL}/users`, { email, demoEnvAccountId });
  return res.data;
}

export async function removeUser(id) {
  await api.delete(`${BASE_URL}/users/${id}`);
}

export async function addAccount({ label }) {
  const res = await api.post(`${BASE_URL}/accounts`, { label });
  return res.data;
}

export async function removeAccount(id) {
  await api.delete(`${BASE_URL}/accounts/${id}`);
}
